import { ReactNode } from 'react';

export type DebugItem = {
  id: string;
  label: string;
  content: ReactNode;
};

type Listener = () => void;

// Items live outside React state so callers can upsert during render without
// re-rendering the DebugProvider's subtree. Only subscribers (the FAB panel)
// re-render when items change.
let items: ReadonlyMap<string, DebugItem> = new Map();
const listeners = new Set<Listener>();

export const subscribeToDebugItems = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const getDebugItemsSnapshot = () => items;

export const upsertDebugItem = (item: DebugItem) => {
  const existing = items.get(item.id);
  if (
    existing &&
    existing.label === item.label &&
    existing.content === item.content
  ) {
    return;
  }
  const next = new Map(items);
  next.set(item.id, item);
  items = next;
  listeners.forEach((l) => l());
};

export const removeDebugItem = (id: string) => {
  if (!items.has(id)) return;
  const next = new Map(items);
  next.delete(id);
  items = next;
  listeners.forEach((l) => l());
};

export const resetDebugItemsStoreForTesting = () => {
  items = new Map();
  listeners.clear();
};
